import SubHeading from '../../../subHeading/SubHeading'
import './friends.css'

import araGorputzLogo from '../../../../assets/img/entidades-colaboradoras/AraGorputz.png'
import beartsyLogo from '../../../../assets/img/entidades-colaboradoras/BeArtsy.Clara García.png'
import gremiArtesanesLogo from '../../../../assets/img/entidades-colaboradoras/Gremi d_artesanes cicliques.jpeg'
import igualitariumLogo from '../../../../assets/img/entidades-colaboradoras/Igualitarium.png'
import espaiBrotesLogo from '../../../../assets/img/entidades-colaboradoras/logo_brotes-principal.webp'

const meetingRhythm = [
  {
    date: 'Octubre',
    text: 'Bienvenida a todas / Propuestas y necesidades individuales y colectivas.',
  },
  {
    date: 'Diciembre',
    text: 'Valoración acciones Día Mundial de la Menarquia / Día Mundial de la Menopausia / Promoción de productos relacionados con la Cultura Menstrual / Propuestas y necesidades individuales y colectivas.',
  },
  {
    date: 'Febrero',
    text: 'Preparatoria de participación en el 8 de marzo / Propuestas y necesidades individuales y colectivas.',
  },
  {
    date: 'Abril',
    text: 'Preparatoria del Día Internacional de la Salud Menstrual / Propuestas y necesidades individuales y colectivas.',
  },
  {
    date: 'Junio',
    text: 'Cierre de año / Propuestas y necesidades individuales y colectivas.',
  },
]

const collaboratingEntities = [
  { name: 'AraGorputz', logo: araGorputzLogo },
  { name: 'BeArtsy', logo: beartsyLogo },
  { name: 'Gremi d’Artesanes Cícliques', logo: gremiArtesanesLogo },
  { name: 'Igualitarium', logo: igualitariumLogo },
  { name: 'Espai Brotes', logo: espaiBrotesLogo },
]

export default function Friends() {
  return (
    <section className='friends section__padding' id='friends'>
      <SubHeading
        title='Amigas-Colaboradoras'
        color={true}
      />

      <div className='friends__text p__main'>
        <p>Es un tiempo histórico de gran fecundidad en relación con los proyectos y emprendimientos vinculados a la nueva Cultura Menstrual y el empoderamiento femenino. En este espacio presentamos a nuestras Amigas-colaboradoras dedicadas al cuidado y acompañamiento en ámbitos como el educativo, de la investigación, la salud, el activismo o de creación y distribución de materiales de gestión del flujo menstrual y el autocuidado, entre otros.</p>
        <p>Para saber más de cómo hacerte amiga colaboradora o amiga donadora, ves directa <a href='/hazte-amiga'>aquí</a>.</p>
      </div>

      <div className='meetings'>
        <SubHeading
          title='Cómo nos encontramos'
          color={true}
        />

        <div className='meetings__intro p__main'>
          <p>La Junta se reúne entre una y dos veces al mes, además de mantener comunicación continua por correo, WhatsApp y teléfono. La Junta ampliada, que incluye a las vocales colaboradoras, se reúne mensualmente o cada dos meses.</p>
          <p>Con las amigas colaboradoras celebramos cada dos meses las reuniones Cíclica_mente reunidas, cinco encuentros que marcan el ritmo de nuestra actividad colectiva:</p>
        </div>

        <div className='meetings__rhythm'>
          {meetingRhythm.map((meeting) => (
            <article key={meeting.date} className='meetings__card'>
              <h3>{meeting.date}</h3>
              <p>{meeting.text}</p>
            </article>
          ))}
        </div>

      </div>

      <section className='collaborating-entities' aria-labelledby='collaborating-entities-title'>
        <SubHeading title='Entidades colaboradoras y aliadas' color={true} />
        <p className='collaborating-entities__intro p__main'>
          Entidades con las que colaboramos en la organización de talleres, jornadas y otras actividades, y que contribuyen al apoyo y sostenimiento de La Vida en Rojo.
        </p>
        <div className='collaborating-entities__logos'>
          {collaboratingEntities.map((entity) => (
            <div className='collaborating-entities__logo' key={entity.name}>
              <img src={entity.logo} alt={`Logo de ${entity.name}`} />
            </div>
          ))}
        </div>
      </section>
    </section>
  )
}
